// extracted by mini-css-extract-plugin
export default {"searchByShip":"SearchByShip_searchByShip__Ujut6"};